import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  itemText: {
    marginBottom: 5,
  },
  orderText: {
    marginBottom: 15,
  },
  viewAll: {
    borderWidth: 1,
    marginHorizontal: '38%',
    borderRadius: 50,
    paddingVertical: 2,
    marginVertical: 10,
    marginBottom: 15,
  },
});
